import { ItemPopover } from '@interfaces'

export enum OfferType {
	PERCENTAGE = 0,
	FREE_DAYS = 1
}

export enum OfferTypeChooser {
	URL = 0,
	CODE = 1,
	IN_THE_PLAN = 2
}

export interface PromotionResponse {
	content: Promotion[]
	number: number
	numberOfElements: number
	totalPages: number
	totalElements: number
}

export interface Promotion {
	active: boolean
	id: number
	numIteractions: number
	maximumUsage: number
	amount: number
	freeDays: number
	translations: PromotionTranslation[]
	offerPlans: PromotionPlan[]
	offerApplyTypes: PromotionApplyType[]
	offerUserTypes: PromotionUserType[]
	paymentType: PromotionType
	offerType: OfferType
	offerTypeChooser: OfferTypeChooser
	chooserValue: string
	dateStart: Date
	dateEnd?: Date
	statusUpdateDate?: Date
	popover: PromotionPopover
	code: string
	numUsages: number
	cancellationOffer: boolean
}

export interface PromotionApplyType {
	id: number
	active: boolean
	applyType: PromotionType
}

export interface PromotionUserType {
	id: number
	active: boolean
	userType: PromotionType
}

export interface PromotionTranslation {
	id: number
	idLibLanguage: number
	name: string
	description: string
}

export interface PromotionPlan {
	id: number
	active: boolean
	plan: PromotionPlanRelation
	offer: Promotion
}

export interface PromotionPlanRelation {
	id: number
	translations: PromotionPlanTranslation[]
}

export interface PromotionPlanTranslation {
	id: number
	name: string
}

export interface PromotionType {
	id: number
	active: boolean
	description: string
}

export interface PromotionPopover {
	plans: { content: ItemPopover[]; translation: string }
	applyTypes: { content: ItemPopover[]; translation: string }
	userTypes: { content: ItemPopover[]; translation: string }
}
